import styled from "styled-components";
import { Grid } from "@nexthink/kendo-react";
import { apolloFontFamilyBody, apolloFontSizeBody, apolloLineHeightBody } from "@nexthink/apollo-tokens";
import Flex from "../box/Flex";
import { StyledTableCellSelection } from "./TableSelectionColumn.style";
import { StyledTableCellGroupingChild } from "./TableGroupingColumn.style";
import { StyledTableCell } from "./TableCell.style";
import { StyledTableActionColumnContainer, StyledTableActionButtonsContainer } from "./TableActionColumn.style";
import { HEADER_MAX_HEIGHT } from "./TableHeaderCell.style";
import { FOCUS_VISIBLE_WITHIN_CLASSNAME } from "./useFocusVisibleWithin";
import { HiddenButtonIcon } from "../menu/KebabActionMenu.style";
// for a nicer scroll experience when scrolling with keyboard, snap scroll to top/bottom when close
export const scrollPadBuffer = 8;
export const headerMaxHeightPadded = `calc(${HEADER_MAX_HEIGHT} + ${scrollPadBuffer}px)`;
export const StyledTableWrapper = styled(Flex).withConfig({ displayName: "StyledTableWrapper_APC-7281-productShell", componentId: "sc-ikr88k" })(({ theme }) => ({
    background: theme.colors.apolloColorBackgroundTableCellDefault,
    scrollPaddingTop: headerMaxHeightPadded,
    scrollPaddingBottom: scrollPadBuffer,
}));
export const StyledTable = styled(Grid).withConfig({ displayName: "StyledTable_APC-7281-productShell", componentId: "sc-khi3t5" })(({ theme, colConfig, tableLayout }) => {
    const colGroup = colConfig.reduce((obj, col) => {
        Object.assign(obj, { [`.k-grid-table col:nth-of-type(${col.index + 1})`]: { width: col.width } });
        return obj;
    }, {});
    const layout = tableLayout === "fixed" ? "fixed" : "auto";
    return Object.assign({ background: theme.colors.apolloColorBackgroundTableCellDefault, display: "flex", flexDirection: "column", width: "100%", ["table, tbody, tfoot, thead, tr, th, td"]: {
            // from reset css
            margin: 0,
            padding: 0,
            border: 0,
            font: "inherit",
            verticalAlign: "baseline",
        }, ["table"]: {
            // from reset css
            borderCollapse: "collapse",
            borderSpacing: 0,
            tableLayout: layout,
            width: "100%",
            // apollo style
            fontFamily: apolloFontFamilyBody,
            fontSize: apolloFontSizeBody,
            lineHeight: apolloLineHeightBody,
            color: theme.colors.apolloColorTextPrimary,
        }, 
        // ["td"]: {
        //   boxSizing: "border-box",
        // },
        [".k-grid-norecords"]: {
            display: "none",
        }, [".k-grid-header"]: {
            display: "none",
        }, [".k-header"]: {
            verticalAlign: "top",
            background: theme.colors.apolloColorBackgroundTableCellDefault,
        }, [".k-header.k-grid-header-sticky"]: {
            position: "sticky",
            right: 0,
        }, [".k-grid-container"]: {
            display: "flex",
            flex: "1 1 auto",
        }, [".k-grid-content"]: {
            width: "100%",
            minHeight: 0,
            position: "relative",
            flex: 1,
        } }, colGroup);
});
export const StyledTableRow = styled.tr.withConfig({ displayName: "StyledTableRow_APC-7281-productShell", componentId: "sc-1l1zmjn" })(({ theme, isSelected, selectable, isFirstChildInGroup, isLastChildInGroup, groupHasMoreData, variant, isHeader, }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ cursor: selectable ? "pointer" : undefined }, (isHeader && {
    // has to be applied on TH since firefox doesn't support sticky TRs very well
    "& th": {
        position: "sticky",
        top: 0,
        zIndex: 2, // above the data rows and the sticky actions column
    },
})), { "& td": {
        background: isSelected
            ? theme.colors.apolloColorBackgroundTableCellSelected
            : theme.colors.apolloColorBackgroundTableCellDefault,
    } }), (isFirstChildInGroup && {
    "& td:after": {
        content: "''",
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        height: variant === "compact" ? "2px" : "4px",
        zIndex: 1,
        background: theme.colors.apolloColorFillTableGroupShadow,
        pointerEvents: "none",
    },
})), (isLastChildInGroup &&
    !groupHasMoreData && {
    [`& ${StyledTableCellGroupingChild}`]: {
        bottom: "1px", // cover the bottom border of the previous group child
    },
})), (isLastChildInGroup &&
    groupHasMoreData && {
    [`& ${StyledTableCell}`]: {
        boxShadow: "none",
    },
})), { [StyledTableCellSelection]: {
        opacity: isSelected || isHeader ? 1 : 0,
    }, [`&:hover, &.${FOCUS_VISIBLE_WITHIN_CLASSNAME}`]: {
        [`${StyledTableActionColumnContainer} ${StyledTableActionButtonsContainer}, ${StyledTableActionColumnContainer} ${HiddenButtonIcon}, ${StyledTableCellSelection}`]: {
            opacity: 1,
        },
        [`${StyledTableCell}`]: {
            background: isSelected
                ? theme.colors.apolloColorBackgroundTableCellSelectedHover
                : theme.colors.apolloColorBackgroundTableCellHover,
        },
    } })));
//# sourceMappingURL=Table.style.js.map